import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Exported as a module singleton (rather than created inside a component) so
 * router loaders can prime the cache before the tree renders.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The upstream fan-out is cached server-side for 45s; refetching more
      // eagerly than that just burns requests for identical data.
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      // Tab-focus refetching is noisy in a task app people leave open all day.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.isAuthError || error.status === 404)) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      // A failed write is surfaced to the user rather than silently retried,
      // since retrying a non-idempotent POST can duplicate it.
      retry: false,
    },
  },
});
